import { render } from "./CardPromo.vue?vue&type=template&id=dafcb9b4&ts=true"
import script from "./CardPromo.vue?vue&type=script&lang=ts"
export * from "./CardPromo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/deploy/wesgroup-production/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__